{
  "addButtonLabel": "Add medication",
  "dose": "Dose",
  "dosePlaceholder": "e.g. 500mg or 1 tablet",
  "dropHere": "Drop here",
  "dropText": "<p>{{fileExtensions}} or {{fileExtension}} up to {{mb}}MB</p>",
  "dropTitle": "<p><strong>Upload a file</strong> or drag and drop</p>",
  "frequency": "Frequency",
  "manuallyText": "<strong>Add medications manually</strong><p>Add one medication at a time. Include the name, dose and how often you take it.</p>",
  "medicationName": "Medication name",
  "medicationPlaceholder": "e.g. Metformin",
  "nextLabel": "$t(common:next): <b>History</b>",
  "saveButton": "Save medication",
  "select": {
    "as-needed": "As needed",
    "once-daily": "Once daily",
    "three-time-daily": "Three times daily",
    "twice-daily": "Twice daily"
  },
  "text": "<p>Please tell us about any other medications, inhalers, injections, or supplements you’re currently taking not already mentioned.</p><p>You can upload a list or add them manually.</p>",
  "title": "Other medications",
  "uploadText": "<strong>Upload a prescription or list</strong><p>If you have a list from your GP or pharmacy, upload a photo or PDF.</p>"
}
